// extracted by mini-css-extract-plugin
export default {"buttons":"B3PwQ","button":"Okeb3","selected":"muDET","positioning":"P5QIc"};